import { Navigate } from "react-router-dom";
import { useSessao } from "@/app/AuthContext";
import { Carregando } from "@/components/layout/Carregando";
import { LandingPage } from "@/features/landing/pages/LandingPage";

/**
 * A raiz do dominio serve as duas coisas: landing publica para visitante,
 * atendimento para quem esta logado. Ver PLANO.md secao 4.1.
 *
 * Nao renderiza a landing enquanto a sessao carrega, senao o usuario logado ve
 * a pagina de vendas piscar antes de cair no app.
 */
export function Raiz() {
  const sessao = useSessao();

  if (sessao.situacao === "carregando") return <Carregando />;
  if (sessao.situacao === "pronto") return <Navigate to="/atendimento" replace />;
  if (sessao.situacao === "sem_empresa") return <Navigate to="/comecar" replace />;
  return <LandingPage />;
}
